import store from "@/store";
import {
  getLoginAction12306,
  getLoginOutAction12306,
  getFaceVerificationAction,
  getMessageVerification,
  sendCaptchaResult,
  validateUserAccount,
  getAllUserAccount,
  deleteUserAccount,
  registerCxVipApi,
} from "@/api/login12306";
import { getUserReverse } from '@/api/train/index';
import { LOAD_FAIL_CONTENT } from "@/common/constant";
import { innerRouter, pagePath } from '@/common/jump';
import { trackEvent } from '@/common/track';
import { mpx } from "@didi/es-mpx-creator";

async function loginAction12306({ state, commit, dispatch }, options) {
  const startTimeLog = new Date().getTime();
  return getLoginAction12306(options).then(res => {
    const { data, code, success, message } = res || {}
    const endTimeLog = new Date().getTime();
    const deltaTime = endTimeLog - startTimeLog;
    trackEvent('userteam_train_login_time', 'UT-火车票-登陆-接口耗时', { deltaTime })
    if (success) {
      if (['0', '10607', '10602', '10603', '10610'].includes(code)) {
        commit('login12306', { code, data, message, options })
      }
      if (!['10607', '10602', '10603', '10610'].includes(code)) {
        dispatch('updateAllUserAccount')
      }
      if (code === "0") {
        const url = state?.fullPath;
        //车次详情页面 未登录 点击预订时 会在url上增加preTicket标识
        const pre = url?.indexOf("preTicket") > -1;
        //乱码七糟什么意思？？？ 首页和密码找回页面都会有isIndex标示？ 这块是不是有问题？？
        const isIndex = url?.indexOf("isIndex") > -1;
        if(options.tickets12306) {
          innerRouter.replace(pagePath().ORDERLIST)
        }
        //不是从预订页面进行的登录
        if (!pre) {
          // 从首页/审核成功然后静默登录失败之后 跳到登录页面然后登录页面登录成功之后跳转到账号管理页面
          if (isIndex) {
            //从首页登录后跳转到账号管理页面
            mpx.showToast({
              title: "登录成功",
              icon: "success",
              duration: 2000,
              mask: true,
            });
            commit('checkCxvipPupup')
            commit('setChangeUserStatus', false)
            return false;
          }
          //这快能走到么？？？ 为什么会直接返回呢
          //不是预订页面进来的  目前就是首页进来的
          mpx.showToast({
            title: '登录成功',
            icon: 'success',
            duration: 2000,
            mask: true,
            success: res => {
              if(options.makeOrderLoginCb) options.makeOrderLoginCb()
              else commit('checkCxvipPupup', {
                closeCb: innerRouter.goback
              })
            }
          });
        } else {
          // 预发未登录之后登录成功调回预发页面
          store.commit("train.setTrainPre", { is_login: true });
          mpx.showToast({
            title: "登录成功",
            icon: "success",
            duration: 2000,
            mask: true,
            success: () => {
              commit('checkCxvipPupup', {
                closeCb: innerRouter.goback
              })
            },
          });
        }
      } else if (code === '10610') {
        innerRouter.push(pagePath().VERIFICATIONCODE, { code })
      } else if (!["10607", "10602", "10603", '10610'].includes(code)) {
        mpx.showToast({
          title: message,
          icon: "error",
          duration: 2000,
          mask: true,
        });
      }
    } else {
      mpx.showToast({
        title: LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
        mask: true,
      });
    }
  });
}

export function registerCxVip({ state, commit, dispatch }, options) {
  registerCxVipApi(options).then(res => {
    const { code, data, success, message } = res
    if(success && code === "0") {
      commit("faceVerification", { code })
      commit('login12306', { code, data })
      innerRouter.goback()
    }else{
      commit("faceVerification", { code: null });
      mpx.showToast({
        title: message || LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
        mask: true,
      });
    }
  }).catch((e) => {
    commit("faceVerification", { code: null });
    mpx.showToast({
      title: LOAD_FAIL_CONTENT,
      icon: "error",
      duration: 2000,
      mask: true,
    });
  });
}

// 人脸核验
export async function faceVerificationAction({ state, commit, dispatch }, options) {
  return new Promise((resolve) => {
    getFaceVerificationAction(options).then(async res => {
      const { data, code, success, message } = res
      if (success) {
        commit("faceVerification", { code })
        if (code === "0") {
          options.faceVerification && store.commit('tickets12306.setNeedLogin12306', false)
          // 人脸核验成功，触发静默登录
          const params = {
            account: data?.account || options?.account,
            password: data?.password || options?.password,
            account_with_star: data?.account_with_star || options?.account_with_star,
            type: options?.type,
          };
          commit('setChangeUserStatus', false)
          try {
            await dispatch("silentLoginAction", { ...params });
          } catch (e) {}
        } else {
          mpx.showToast({
            title: message,
            icon: "error",
            duration: 2000,
            mask: true,
          });
        }
      } else {
        commit("faceVerification", { code: null });
        mpx.showToast({
          title: LOAD_FAIL_CONTENT,
          icon: "error",
          duration: 2000,
          mask: true,
        });
      }
      resolve()
    }).catch((e) => {
      commit("faceVerification", { code: null });
      mpx.showToast({
        title: '查看失败，请重试',
        icon: "error",
        duration: 2000,
        mask: true,
      });
      resolve()
    });
  })
}

// 短信核验
export async function messageVerification({ state, commit, dispatch }, options) {
  mpx.showLoading();
  return getMessageVerification(options).then((res) => {
    const { data, code, success, message } = res;
    if (success) {
      // 短信登录成功 =>触发静默登录
      if (code === "0") {
        const params = {
          account: data?.account || options?.account,
          password: data?.password || options?.password,
          account_with_star: data?.account_with_star || options?.account_with_star,
          type: options?.type,
          tickets12306: options.tickets12306
        };
        commit('setChangeUserStatus', false)
        try {
          dispatch("silentLoginAction", { ...params });
          return true;
        } catch (e) {
          return false;
        }
      } else {
        mpx.hideLoading();
        mpx.showToast({
          title: message,
          icon: "error",
          duration: 2000,
          mask: true,
        });
      }
      //       innerRouter.replace(url, {...mpx.$mpxRoute?.query})
      return true;
    } else {
      mpx.hideLoading();
      mpx.showToast({
        title: LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
        mask: true,
      });
    }
  }).catch((e) => {
    mpx.hideLoading();
    mpx.showToast({
      title: LOAD_FAIL_CONTENT,
      icon: "error",
      duration: 2000,
      mask: true,
    });
  });
}

// 退出当前账号
async function loginOutAction12306({ commit, dispatch }, options) {
  getLoginOutAction12306(options).then(async ({ code, success, message }) => {
    if (success && code === "0") {
      mpx.removeStorage({ key: "backPageUrl" })
      mpx.showToast({
        title: "退出成功",
        icon: "success",
        duration: 2000,
        mask: true,
      })
      await dispatch('updateAllUserAccount')
      commit('setChangeUserStatus', false)
    } else {
      mpx.showToast({
        title: message || LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
        mask: true,
      })
    }
  })
}

// 初始获取12306登录状态 仅首页展示提示用
function init12306LoginStatusAction({ commit }) {
  validateUserAccount({}).then(res => {
    const { data, code, success } = res || {}
    if (success && code === "0") {
      const userAccountStatus = data?.channel === 'app'
        ? !!data?.account?.login
        : true
      commit("setUserAccountStatus", userAccountStatus)
      if (userAccountStatus) {
        commit('login12306', { code, data: data.account })
      } else {
        commit('clearInfo12306')
      }
    } else {
      commit("setUserAccountStatus", false)
    }
  })
}

// 删除12306账户信息
function delete12306UserAccount({ dispatch }, options) {
  deleteUserAccount(options).then(({ message, code, success }) => {
    if (success && code === "0") {
      mpx.showToast({
        title: '删除成功',
        icon: "success",
        duration: 2000,
        mask: true,
      })
      dispatch('updateAllUserAccount')
    } else {
      mpx.showToast({
        title: message || LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
        mask: true,
      })
    }
  })
}

// 获取历史登录过的12306账户列表
async function updateAllUserAccount({ state, commit }) {
  return getAllUserAccount({}).then((res) => {
    const { message, data, code, success } = res || {}
    if (success && code === "0") {
      commit("setUserAccountList", data?.userAccount || [])
      data?.channel && commit("setAccountChannel", data.channel)
      const loginAccount = data?.userAccount?.find(item => item.login)
      if (!loginAccount) {
        commit('clearInfo12306')
      } else {
        commit('login12306', { code: '0', data: loginAccount })
      }
    } else {
      commit("setUserAccountList", [])
      commit('clearInfo12306')
      mpx.showToast({
        title: message || LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
        mask: true,
      })
    }
  })
}

// 审核通过过来的 ==>>>>  人脸审核通过的静默登录
export async function silentLoginAction({ state, commit, dispatch }, options) {
  const url = state?.fullPath;
  return getLoginAction12306({ type: 0, ...options }).then((res) => {
    mpx.hideLoading();
    const { data, code, success, message } = res;
    console.log(res, "人脸审核通过的静默登录");

    if (success) {
      console.log("success=======>")
      if (code === "0") {
        commit('login12306', { code, data, options })
        dispatch('updateAllUserAccount')
        // 静默登录成功
        // 多一个判断 如果 是 从其他的页面进来的话，需要返回其他的那个页面，除首页登录除外
        // 需要区分 从首页过来 ， 从 预订页面过来 ，从其他的页面过来的跳转
        const url = state?.fullPath;
        console.log(url, "返回的url登录成功之后");
        // pages/home/index
        // 预订页面过来的 会有preTicket 标识
        // 预订页面回调
        const pre = url.indexOf("preTicket") > -1;
        const isIndex = url?.indexOf("isIndex") > -1;
        //如果是预订页面 触发风控
        if (pre) {
          store.commit("train.setTrainPre", { is_login: true });
          console.log("又走预订的页面了");
          //看看 人脸核验返回2步
          // innerRouter.replace(preUrl);
          mpx.showToast({
            title: "核验成功",
            icon: "success",
            duration: 2000,
            mask: true,
            success: () => {
              commit('checkCxvipPupup', {
                closeCb: () => {
                  mpx.navigateBack({
                    delta: 2,
                  })
                }
              })
            },
          });

          return false;
        }
        //人脸识别可以在退改任何流程都触发， 如果不是在登录时触发，人脸就回退两个页面栈，如果是短信，就返回一个页面栈
        // 登录后的从其他的页面登录成功之后返回的 
        ///这块表示不是从首页，也不是从预订页面 那么就是其他环节的静默登录
        if (!(url.indexOf("pages/login12306/index") > -1)) {
          //看看 人脸核验返回1步
          // innerRouter.replace(url); // 返回上一页
          console.log(url, "需要返回1级");
          mpx.showToast({
            title: "核验成功",
            icon: "success",
            duration: 2000,
            mask: true,
            success: (res) => {
              // innerRouter.redirect(url);
              innerRouter.goback();
              // mpx.navigateBack({
              //   delta: state.isSmsCode > 2 ? 2 : 1, // 1 = >  区分是否是短信核验还是人脸核验
              // });
            },
          });
          return false;
        }
        //如果是首页 那这块就返回到账号管理页面
        if (isIndex) {
          // 从 首页点击登录到登录页然后又触发风控审核成功之后返回到账号管理页面
          mpx.showToast({
            title: "核验成功",
            icon: "success",
            duration: 2000,
            mask: true,
            success: (res) => {
              //todo。。。。
              innerRouter.goback();
              // innerRouter.redirect(
              //   pagePath().LOGIN12306, {
              //     isIndex: 'current',
              //     from: 'home'
              //   }
              // );
            },
          });
          return false;
        }
        // 从12306 登录页面成功之后的跳转

        console.log("从12306 登录页面成功之后的跳转");
        // mpx.navigateBack({
        //   delta: state.isSmsCode > 2 ? 3 : 2, // 1 = >  区分是否是短信核验还是人脸核验  // 2 = > 短信  还是 2
        // });
        //切换账号=
        console.log("切换账号===========>")
        mpx.showToast({
          title: "核验成功",
          icon: "success",
          duration: 2000,
          mask: true,
          success: (res) => {
            mpx.navigateBack({
              // delta: 3, // 2 = > 短信  还是 2 todo:
              // delta: state.isSmsCode > 2 ? 3 : 2, // 1 = >  区分是否是短信核验还是人脸核验
              delta: 2, // 1 = >  区分是否是短信核验还是人脸核验
            });
            // innerRouter.redirect(pagePath().LOGIN12306, {
            //   from: 'home'
            // });
          },
        });
      } else {
        dispatch("handleSilentLoginError");
        return true;
      }
    } else {
      mpx.hideLoading();
      dispatch("handleSilentLoginError");
      return true;
    }
  }).catch((e) => {
    mpx.hideLoading();
    dispatch("handleSilentLoginError");
    console.log("eeeeeeeee=>", e)
    return true;
  });
}

export async function handleSilentLoginError({ state, commit }, options) {
  const url = state?.fullPath;
  //理论上不走这里 正常风控之后，人脸核验成功的话，走静默登录是一定成功的，这块属于异常逻辑
  // mpx.showToast({
  //   title: "核验成功，请重新登录",
  //   icon: "success",
  //   duration: 2000,
  //   mask: true,
  //   success: (res) => {},
  // });
  // 审核成功之后的 请求登录接口，然后登录返回失败，跳转到登录页面从新登录 这快的跳转看着有点问题？？？？？？？
  // 因为时间紧张，重构不可控等因素，所以按照原有代码逻辑进行修改，有时间这块需要重构
  console.log("url======>", url)
  const pre = url.indexOf("preTicket") > -1;
  const isIndex = url?.indexOf("isIndex") > -1;
  if (pre) {//预订页面
    mpx.showToast({
      title: "核验成功，请重新登录",
      icon: "success",
      duration: 2000,
      mask: true,
      success: () => {
        commit('checkCxvipPupup', {
          closeCb: () => {
            mpx.navigateBack({
              delta: 2,
            })
          }
        })
      },
    });
    return
  }
  if (isIndex) {//如果是从首页进去的 风控核验成功 静默登录失败之后，就直接回到登录页面 让用户重新登录
    mpx.showToast({
      title: "核验成功，请重新登录",
      icon: "success",
      duration: 2000,
      mask: true,
      success: (res) => {
        innerRouter.goback();
      },
    });
    return
  }
  //其他流程触发风控 人脸核验成功但是登录失败，也按照成功处理，直接跳转回 触发风控的页面
  mpx.showToast({
    title: "核验成功，请重新操作",
    icon: "success",
    duration: 2000,
    mask: true,
    success: (res) => {
      innerRouter.goback();
    },
  });
}

// 其他页面 已登录的状态触发 风控的时候第一步先走这里静默请求 获取手机号等相关信息
export async function quietAction({ state, commit, dispatch }, options) {
  return getLoginAction12306({ type: 1, ...options }).then((res) => {
    mpx.hideLoading();
    const { data, code, success, message } = res;
    if (success) {
      commit('login12306', { code, data, options })
      if (code === "0") {
        //这干什么的？？ todo  静默登录成功, 这块应该是不会走到的，如果走到 说明后端有问题
        mpx.showToast({
          title: "请重新操作",
          icon: "success",
          duration: 2000,
        });
        return true;
      } else if (!["10607", "10602", "10603"].includes(code)) {
        //如果没有出发风控状态码 而是其他错误 那么弹一个toast提示
        //这块是什么意思？？？？？ 为什么要跳转登录页面？？？？？ 这块是通过静默登录 获取到人脸数据 为什么要跳转？？？
        //todo zhangzhipeng 除了风控其他的弹toast
        mpx.showToast({
          title: message,
          icon: "error",
          duration: 2000,
        });
      }
    } else {
      mpx.showToast({
        title: LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
      });
    }
  }).catch((e) => {
    mpx.hideLoading();
    mpx.showToast({
      title: LOAD_FAIL_CONTENT,
      icon: "error",
      duration: 2000,
    });
  });
}

export async function sendCaptchaResultAction({ state, commit }, options) {
  mpx.showLoading();
  return sendCaptchaResult(options).then((res) => {
    mpx.hideLoading();
    const { data, code, success, message } = res || {};
    if (success) {
      if (code === "0") {
        commit("sendCaptchaResult", { code, data, success });
        return true;
      } else {
        mpx.showToast({
          title: message,
          icon: "success",
          duration: 2000,
          mask: true,
          success: (res) => { },
        });
      }
    } else {
      mpx.showToast({
        title: LOAD_FAIL_CONTENT,
        icon: "error",
        duration: 2000,
      });
    }
  });
}

async function getCurrentUserReverse({ state, commit }, payload) {
  if (payload?.init) {
    commit('setReverseData', null)
  }
  console.log('state.reverseData', state.reverseData)
  // 如果已经获取到用户信息，直接返回  如果需要强制刷新则重新请求
  if (state.reverseData) {
    return Promise.resolve(state.reverseData)
  } else {
    if(!state.userPendingRequest) {
      state.userPendingRequest = getUserReverse().then(ret => {
        commit('setReverseData', ret);
        state.userPendingRequest = null; // 请求完成后清除锁
        return ret;
      }).catch(error => {
        state.userPendingRequest = null; // 出错也要清除锁
        console.error(error)
      })
    }
    return state.userPendingRequest
  }
}

export default {
  loginAction12306,
  loginOutAction12306,
  faceVerificationAction,
  messageVerification,
  silentLoginAction,
  sendCaptchaResultAction,
  quietAction,
  handleSilentLoginError,
  init12306LoginStatusAction,
  updateAllUserAccount,
  delete12306UserAccount,
  getCurrentUserReverse,
  registerCxVip,
};
